import { callWorker } from '../../../potree/utils/workers/callWorker';
import CadImportWorker from './cadImportWorker?worker';
import type { CadImportFormat, CadImportRequest, CadImportResponse } from './cadImportWorker';
import { parseImportResult, type ImportResult } from './importResult';

/** Drawing formats the importer reads, by file extension. */
export const DRAWING_FORMATS: Readonly<Record<string, CadImportFormat>> = { svg: 'svg', dxf: 'dxf', dwg: 'dwg' };

export const DRAWING_ACCEPT = { 'image/svg+xml': ['.svg'], 'application/dxf': ['.dxf'], 'application/acad': ['.dwg'], 'application/octet-stream': ['.dxf', '.dwg'] };

/** Largest drawing we try to read in the browser. */
export const MAX_DRAWING_BYTES = 50 * 1024 * 1024;

export function drawingFormat(fileName: string): CadImportFormat | null {
  return DRAWING_FORMATS[fileName.split('.').pop()?.toLowerCase() ?? ''] ?? null;
}

/** Read an SVG/DXF/DWG file into shapes (in a worker). Throws with a readable message. */
export async function readDrawing(file: File): Promise<ImportResult> {
  const format = drawingFormat(file.name);
  if (!format) throw new Error('unsupported file type');
  if (file.size > MAX_DRAWING_BYTES) throw new Error('file too large');
  const bytes = await file.arrayBuffer();
  const response = await callWorker<CadImportRequest, CadImportResponse>(() => new CadImportWorker(), { format, bytes }, [bytes]);
  if (!response.ok) throw new Error(response.error);
  const result = parseImportResult(response.json);
  if (!result) throw new Error('unexpected reader output');
  return result;
}
